// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"l8-z","upvoteIcon":"m8-z","downvoteIcon":"n8-z","feedbackIcon":"o8-z"};